import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { InstiMenu } from '../insti/instiMenu';

import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective
} from './accordion';

@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective
  ],
  providers: [
    MenuItems,
    InstiMenu
    ]
})
export class SharedModule {}
 